import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { RequireAuth } from './components/RequireAuth';
import { ChangePasswordPage } from './components/ChangePassword';
import { LoginPage } from './pages/LoginPage';
import { PublicHomePage } from './pages/PublicHomePage';
import { RegisterPage } from './pages/RegisterPage';
import { AdminRegistrationsPage } from './pages/admin/AdminRegistrationsPage';
import { AdminHomePage } from './pages/admin/AdminHomePage';
import { AdminReservationsPage } from './pages/admin/AdminReservationsPage';
import { AdminRequestsPage } from './pages/admin/AdminRequestsPage';
import { AdminLabsPage } from './pages/admin/AdminLabsPage';
import { AdminCoursesPage } from './pages/admin/AdminCoursesPage';
import { AdminShowcasesPage } from './pages/admin/AdminShowcasesPage';
import { AdminExportPage } from './pages/admin/AdminExportPage';
import { AdminMigrationPage } from './pages/admin/AdminMigrationPage';
import { TeacherSchedulePage } from './pages/teacher/TeacherSchedulePage';
import { TeacherReservationNewPage } from './pages/teacher/TeacherReservationNewPage';
import { TeacherRequestNewPage } from './pages/teacher/TeacherRequestNewPage';
import { StudentHomePage } from './pages/student/StudentHomePage';
import { StudentRequestNewPage } from './pages/student/StudentRequestNewPage';
import { StudentCoursesPage } from './pages/student/StudentCoursesPage';
import { StudentShowcasesPage } from './pages/student/StudentShowcasesPage';
import { KioskLoginPage } from './pages/kiosk/KioskLoginPage';
import { KioskShell } from './pages/kiosk/KioskShell';
import { KioskCoursesPage } from './pages/kiosk/KioskCoursesPage';
import { KioskEnrollmentsPage } from './pages/kiosk/KioskEnrollmentsPage';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<PublicHomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/change-password" element={<ChangePasswordPage />} />
      <Route path="/kiosk/login" element={<KioskLoginPage />} />
      <Route
        path="/kiosk"
        element={
          <RequireAuth roles={['student']} kiosk>
            <KioskShell />
          </RequireAuth>
        }
      >
        <Route path="courses" element={<KioskCoursesPage />} />
        <Route path="enrollments" element={<KioskEnrollmentsPage />} />
      </Route>
      <Route
        path="/admin"
        element={
          <RequireAuth roles={['admin']}>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="home" element={<AdminHomePage />} />
        <Route path="reservations" element={<AdminReservationsPage />} />
        <Route path="requests" element={<AdminRequestsPage />} />
        <Route path="registrations" element={<AdminRegistrationsPage />} />
        <Route path="labs" element={<AdminLabsPage />} />
        <Route path="courses" element={<AdminCoursesPage />} />
        <Route path="showcases" element={<AdminShowcasesPage />} />
        <Route path="export" element={<AdminExportPage />} />
        <Route path="migration" element={<AdminMigrationPage />} />
      </Route>
      <Route
        path="/teacher"
        element={
          <RequireAuth roles={['teacher']}>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="schedule" element={<TeacherSchedulePage />} />
        <Route path="reservations/new" element={<TeacherReservationNewPage />} />
        <Route path="requests/new" element={<TeacherRequestNewPage />} />
      </Route>
      <Route
        path="/student"
        element={
          <RequireAuth roles={['student']}>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="home" element={<StudentHomePage />} />
        <Route path="requests/new" element={<StudentRequestNewPage />} />
        <Route path="courses" element={<StudentCoursesPage />} />
        <Route path="showcases" element={<StudentShowcasesPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
